// src/components/YourPath/RutasDidacticasFormStep1.js
import React, { useState } from "react";
import { Modal, Form, Button, TextArea, Confirm, Dropdown } from "semantic-ui-react";
import { useFormik } from "formik";
import { buildInitialValues, validationSchema } from "./RutasDidacticasForm.form";
import { DidacticRoutesAPI } from "../../../../api";

import "./RutasStep.scss"; // <— import del SCSS unificado

const didacticRoutesAPI = new DidacticRoutesAPI();

export function RutasDidacticasFormStep1({
  accessToken,
  teacher,
  onRouteCreated,
  onClose,
  onReload,
  forceCreateMode,
}) {
  const [showConfirm, setShowConfirm] = useState(false);
  const [loading, setLoading] = useState(false);

  const formik = useFormik({
    initialValues: buildInitialValues(),
    validationSchema: validationSchema(),
    validateOnChange: false,
    onSubmit: () => setShowConfirm(true),
  });

  // Generar opciones de módulo/clase
  const classOptions = (teacher?.classrole || []).map((item) => ({
    key: item.classnumber,
    text: item.classnumber,
    value: item.classnumber,
  }));

  const handleConfirm = async () => {
    setShowConfirm(false);
    setLoading(true);
    try {
      const data = {
        nameRute: formik.values.nameRute,
        description: formik.values.description,
        classnumber: formik.values.classnumber,
        institution_Id: teacher.institution,
      };

      const result = await didacticRoutesAPI.createDidacticRoute(
        accessToken,
        teacher._id,
        teacher.institution._id,
        data
      );
      const newRouteId = result.route._id;
      const routeDetail = await didacticRoutesAPI.getRouteById(accessToken, newRouteId);

      onRouteCreated?.(routeDetail.route);
      onReload?.();
    } catch (error) {
      console.error("Error al crear el Itinerario:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancelConfirm = () => setShowConfirm(false);

  return (
    <>
      <Modal.Header>Crear Nuevo Itinerario Didáctico</Modal.Header>

      <Modal.Content className="rutas-step1"> {/* <— clase raíz */}
        <Form onSubmit={formik.handleSubmit} className="rutas-step1__form">
          <Form.Input
            label="Nombre del Itinerario"
            name="nameRute"
            value={formik.values.nameRute}
            onChange={formik.handleChange}
            error={
              formik.errors.nameRute
                ? { content: formik.errors.nameRute, pointing: "above" }
                : null
            }
            className="rutas-step1__field"
          />

          <Form.Field
            control={TextArea}
            label="Descripción del Itinerario"
            name="description"
            value={formik.values.description}
            onChange={formik.handleChange}
            error={
              formik.errors.description
                ? { content: formik.errors.description, pointing: "above" }
                : null
            }
            className="rutas-step1__field"
          />

          <Form.Field error={!!formik.errors.classnumber} className="rutas-step1__field">
            <label>Nombre del módulo o clase</label>
            <Dropdown
              placeholder="Selecciona un módulo o clase"
              fluid
              selection
              options={classOptions}
              value={formik.values.classnumber}
              onChange={(_, { value }) => formik.setFieldValue("classnumber", value)}
            />
            {formik.errors.classnumber && (
              <div className="rutas-step1__error">{formik.errors.classnumber}</div>
            )}
          </Form.Field>

          <div className="rutas-step1__buttons">
            <Button type="submit" primary loading={loading}>
              Crear Itinerario
            </Button>
            <Button type="button" onClick={onClose} disabled={loading}>
              Cancelar
            </Button>
          </div>
        </Form>
      </Modal.Content>

      <Confirm
        open={showConfirm}
        onCancel={handleCancelConfirm}
        onConfirm={handleConfirm}
        content={`¿Estás seguro de que quieres crear el itinerario "${formik.values.nameRute}"?`}
      />
    </>
  );
}
